import { SearchInput } from '@billy/design-system'
import React, { ChangeEvent, ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useBillsListFilters } from '../../hooks/useBillsListFilters'

export const BillsSearch = (): ReactElement => {
  const { t } = useTranslation()
  const [{ searchQuery }, setFilters] = useBillsListFilters()

  const isSearchInputFocused = !!searchQuery

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setFilters({ page: 1, searchQuery: event.target.value || undefined })
    },
    [setFilters],
  )

  const handleClear = useCallback(() => {
    setFilters({ page: 1, searchQuery: undefined })
  }, [setFilters])

  return (
    <SearchInput
      focused={isSearchInputFocused}
      onChangeDebounced={handleChange}
      onClear={handleClear}
      placeholder={`${t('search')}...`}
      value={searchQuery}
    />
  )
}
